export interface PlansI {
  id: number;
  name: string;
  description: string;
  features: string;
  serviceId: number;
  price: number;
  currency: string;
  billingCycle: string;
  trialDays: number;
}

export interface PlansStateI {
  plans: PlansI[];
  plan: PlansI; // Optional, used when a single plan is needed
}

export const state: PlansStateI = {
  plans: [],
  plan: {
    id: 0,
    name: '',
    description: '',
    features: '',
    serviceId: 0,
    price: 0,
    currency: '',
    billingCycle: '',
    trialDays: 0,
  },
};
